<template>
  <div class="tiktok-analytics-public-header">
    <div class="custom-title" layout layout-align="start-center">
      <el-tooltip :content="campaign.account.name">
        <Icon
          class="mr-x1"
          :picture-url="campaign.account.pictureUrl"
          :name="campaign.account.name"
          :icon-type="campaign.targetSns"
        ></Icon>
      </el-tooltip>
      <div>{{ campaign.title }}</div>
    </div>
    <div class="mt-x1">
      期間: {{ formatDatetime(campaign.startDatetime) }} 〜 {{ formatDatetime(campaign.endDatetime) }}
    </div>
    <div v-if="isCampaignFinalCollection">
      <div class="mt-x1">
        <div class="message message-info">
          分析データの最終集計中です。<br />{{ collectCompletedAt }} ごろまでに最終的なデータが反映されます。
        </div>
      </div>
    </div>
    <div v-else-if="isCampaignCollectionCompleted">
      <div class="mt-x1">
        <div class="message message-info">分析データの最終集計が完了しました。</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import { CAMPAIGN_STATUS } from '@/client/constant'
import { formatDatetime } from '@/client/filters/filters'
import { useTikTokAnalyticsPublicStore } from '@/client/store/useTikTokAnalyticsPublicStore'

export default defineComponent({
  components: { Icon },
  computed: {
    ...mapState(useTikTokAnalyticsPublicStore, {
      campaign: function (state) {
        const campaign = { ...state.campaign }

        if (!campaign.account || !campaign.account.name) {
          campaign.account = {
            name: '削除されたアカウント',
            pictureUrl: require('@/client/assets/images/tiktok_default_profile.png')
          }
        }

        return campaign
      }
    }),

    isCampaignStartingIncludeRetweets() {
      return (
        this.campaign.status === CAMPAIGN_STATUS.DURING_COLLECTION &&
        ['keyword', 'old_web_instantwin'].includes(this.campaign.type) &&
        ['retweet_and_quote_tweet', 'retweet'].includes(this.campaign.entryActionType)
      )
    },

    isCampaignFinalCollection() {
      return this.campaign.status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION
    },

    isCampaignCollectionCompleted() {
      return this.campaign.status === CAMPAIGN_STATUS.COLLECTION_COMPLETED
    },

    collectCompletedAt() {
      // TikTokの分析Batchがキャンペーン終了後2日間まで実行されるため、集計中の状態を2日間継続する
      return moment(this.campaign.endDatetime).add(2, 'days').format('YYYY年MM月DD日 HH:mm')
    }
  },
  methods: {
    formatDatetime
  }
})
</script>
